import {
  SORT_UPDATED,
  QUERY_ADDED,
  QUERY_REMOVED,
  SEARCH_SUCCESS,
  FACET_SELECTED,
  FACET_SELECTED_EXCLUSIVE,
  FACET_DESELECTED,
  FACET_DESELECTED_EXCLUSIVE,
  SEARCH_RESET,
  TAG_FILTER_ADDED,
  TAG_FILTER_REMOVED,
  TAG_FILTERS_UPDATED,
  SEARCH_FAILURE,
} from './search.action';

import { adaptFacets } from './search.state';

// GTM-UPDATE -> GTM UPDATED
const addToDataLayer = (data) => window.dataLayer.push(data);

const queryAdded = (action) => ({
  hitType: 'event',
  eventCategory: 'asset-search',
  eventAction: 'query-Added',
  eventLabel: action.payload,
});

const queryRemoved = (action) => ({
  hitType: 'event',
  eventCategory: 'asset-search',
  eventAction: 'query-Removed',
  eventLabel: action.payload,
});

const searchSuccess = (action, prevState) => {
  const query = prevState.search.query;
  const sort = prevState.search.sort[0];
  const facets = [];
  let hasFiltered = false;
  Object.keys(adaptFacets(prevState.search)).forEach((key) =>
    prevState.search[key].forEach((facet) => {
      if (facet._selected) {
        facets.push({ type: key, value: facet.id });
        hasFiltered = true;
      }
    }),
  );

  if (!hasFiltered) {
    if (
      query.length > 1 ||
      (query.length === 1 && query !== '*') ||
      (!Array.isArray(prevState.search.tagFilters) &&
        Object.keys(prevState.search.tagFilters).length > 0)
    ) {
      hasFiltered = true;
    } else {
      prevState.search.accounts.forEach((account) => {
        if (account._selected) hasFiltered = true;
      });
    }
  }

  const data = {
    sort: prevState.search.sort,
    facets,
  };

  if (hasFiltered) data.totalAssetsFiltered = action.payload.data.total;
  else data.totalAssets = action.payload.data.total;
  addToDataLayer({
    event: 'assetSearchSucceeded',
    data: data,
  });

  return {
    hitType: 'event',
    eventCategory: 'asset-search',
    eventAction: 'search',
    eventLabel: JSON.stringify({
      query: query,
      sort: sort,
      facets: facets,
    }),
    eventValue: action.payload.data.total,
  };
};

export const SearchAnalytics = {
  [QUERY_ADDED]: queryAdded,

  [QUERY_REMOVED]: queryRemoved,

  [SEARCH_SUCCESS]: searchSuccess,

  [SORT_UPDATED]: (action, prevState) =>
    addToDataLayer({
      event: 'sortUpdated',
      data: {
        type: action.payload,
        direction: prevState.search.sort.direction,
      },
    }),

  [FACET_SELECTED]: (action) =>
    addToDataLayer({
      event: 'assetsFiltered',
      data: {
        type: action.payload.facetType,
        value: action.payload.value.id,
      },
    }),

  [FACET_SELECTED_EXCLUSIVE]: (action) =>
    addToDataLayer({
      event: 'assetsFilteredExclusive',
      data: {
        type: action.payload.facetType,
        value: action.payload.value.id,
      },
    }),

  [FACET_DESELECTED]: (action) =>
    addToDataLayer({
      event: 'assetsFilterRemoved',
      data: {
        type: action.payload.facetType,
        value: action.payload.value.id,
      },
    }),

  [FACET_DESELECTED_EXCLUSIVE]: (action) =>
    addToDataLayer({
      event: 'assetsFilteredExclusiveRemoved',
      data: {
        type: action.payload.facetType,
        value: action.payload.value.id,
      },
    }),

  [SEARCH_RESET]: () =>
    addToDataLayer({
      event: 'searchCleared',
    }),

  [TAG_FILTER_ADDED]: (action) =>
    addToDataLayer({
      event: 'assetsTagFilterAdded',
      data: JSON.stringify(action.payload),
    }),

  [TAG_FILTER_REMOVED]: (action) =>
    addToDataLayer({
      event: 'assetsTagFilterRemoved',
      data: action.payload,
    }),

  [TAG_FILTERS_UPDATED]: (action) =>
    addToDataLayer({
      event: 'assetsTagFiltersUpdated',
      data: action,
    }),

  [SEARCH_FAILURE]: (action) =>
    addToDataLayer({
      event: 'searchFailed',
      data: action.payload,
    }),
};
